import * as PropTypes from "prop-types"
import Canonical from "components/Canonical"
import { BreadcrumbJsonLd, NextSeo } from "next-seo"
import { useLocale, useT } from "react-polyglot-hooks"
import { useRouter } from "next/router"
import { useEffect } from "react"
import { shouldHideFromSearch } from "helpers/seoHelpers"
import { useBusinessSeoDescription } from "components/GlobalSeoData/BusinessSeoContext"

export default function RentingSeo({ noindex, variant, seoData }) {
  const t = useT()
  const locale = useLocale()
  const { pathname } = useRouter()
  const { setDescription, resetDescription } = useBusinessSeoDescription()

  const pageDescription = seoData?.seo_description || t(`renting.seo.${variant}.description`)

  useEffect(() => {
    setDescription(pageDescription)
    return () => resetDescription()
  }, [pageDescription, setDescription, resetDescription])

  // Determinar si se debe ocultar de los motores de búsqueda
  const hideFromSearch = shouldHideFromSearch(noindex)

  return (
    <>
      <Canonical page={variant} customPath={seoData?.slug && `/${seoData.slug.replace(/^\/+/, "")}`} />
      <NextSeo
        title={seoData?.seo_title || t(`renting.seo.${variant}.title`)}
        description={pageDescription}
        noindex={hideFromSearch}
        nofollow={hideFromSearch}
        openGraph={{
          type: "website",
          locale: `${locale}_${locale.toUpperCase()}`,
          url: `https://swipcar.com${pathname}`,
          title: `${t(`renting.seo.${variant}.og:title`)} | Swipcar`,
          description: t(`renting.seo.${variant}.og:description`),
          images: [
            {
              url: `${process.env.NEXT_PUBLIC_CLOUDINARY}/static/home/og-renting-cars.png`,
              width: 1200,
              height: 630,
              alt: t(`renting.seo.${variant}.og:title`)
            }
          ]
        }}
      />
      <BreadcrumbJsonLd
        itemListElements={[
          { position: 1, name: "Swipcar", item: `https://swipcar.com/${locale}` },
          { position: 2, name: t(`renting.seo.${variant}.title`).split(" - ")[0], item: `https://swipcar.com${pathname}` }
        ]}
      />
    </>
  )
}

RentingSeo.defaultProps = {
  seoData: null
}

RentingSeo.propTypes = {
  noindex: PropTypes.bool.isRequired,
  variant: PropTypes.string.isRequired,
  seoData: PropTypes.object
}
